<template>
  <div
    class="megamenu-location-groups"
    :class="{ flex: locationGroup.locationName === 'group' }"
  >
    <div class="megamenu-location-groups__item">
      <span
        class="megamenu-location-group__title"
        :class="{
          'h-8': !locationGroup.locationName,
        }"
      >
        {{
          locationGroup.locationName
            ? $t(
                `location.${camelCaseToSnakeCase(
                  locationGroup.locationName
                )}.label`
              )
            : ''
        }}
      </span>

      <MegamenuLocationGroup
        :navigationTree="locationGroup.navigationTree"
        :showChildren="showChildren(locationGroup.locationName)"
        @clickLocationLink="$emit('clickLocationLink', $event)"
      ></MegamenuLocationGroup>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import MegamenuLocationGroup from '@/components/navbar/MegamenuLocationGroup.vue';
import MegamenuLocationGroupTab from '@/components/accordions/MegamenuLocationGroupTab.vue';
import { LocationGroup } from '@/store/navigation/models/LocationGroup';
import GenericAccordion from '@/components/accordions/GenericAccordion.vue';
import { camelCasetoSnakeCase } from '@/helpers/google';
import { DKIcon } from '@dormakaba/dormakaba-components';

@Component({
  components: {
    MegamenuLocationGroup,
    MegamenuLocationGroupTab,
    GenericAccordion,
    DKIcon,
  },
  emits: ['clickLocationLink'],
})
export default class MegamenuLocationGroups extends Vue {
  @Prop() locationGroup!: LocationGroup;

  camelCaseToSnakeCase(value: string): string {
    return camelCasetoSnakeCase(value);
  }

  showChildren(locationGroup: string): boolean {
    return locationGroup !== 'group';
  }
}
</script>
<style lang="postcss" scoped>
.megamenu-location-groups__item {
  @apply pl-5 pr-12 pt-9;
}

.megamenu-location-group__title {
  @apply flex;
  @apply heading-4;
  font-size: 26px;
  line-height: 32px;
}

.megamenu-location-group__icon-group {
  margin-left: 14px;
}
</style>
